import React, { FC, useContext } from 'react'
import { LocaleContext } from './LocaleContext'
import { contentLocales, Locale, localeTitles } from './Locale'
import { LocaleLink } from './LocaleLink'
import classNames from 'classnames'

export const LocaleSwitcher: FC<{
  locales?: Locale[]
  className?: string
}> = (props) => {
  const { pathWithoutLocale } = useContext(LocaleContext)

  return (
    <ul className={classNames('flex text-sm', props.className)}>
      {(props.locales || contentLocales).map((locale) => (
        <li key={locale}>
          <LocaleLink
            className="p-1.5 no-underline hover:underline"
            activeClassName="text-white hover:no-underline"
            hrefLang={locale}
            to={pathWithoutLocale}
            locale={locale}
          >
            {localeTitles[locale]}
          </LocaleLink>
        </li>
      ))}
    </ul>
  )
}
